import { InjectionToken } from "@angular/core";
import { IFiltersSettings } from "../interfaces/filters-settings.interface";

export class FiltersSettingsRef extends InjectionToken<IFiltersSettings> { }
